import React, { FC } from 'react';
import styled from 'styled-components';
import CloudinaryPhoto, { CloudinaryPhotoProps } from '@minecraft.cloudinary-photo';
import CloudinaryVideoAudio from '@minecraft.cloudinary-video-audio';
import { media } from '@minecraft.themes';
import { gqlMedia, gqlMediaTypeCodeEnum as MEDIA_TYPE } from '@minecraft.graphql-types';

const THUMBNAIL_DEFAULT_SIZE = [180, 144];

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem 0 0;

  ${media.sm`
    padding: 0;
    margin-bottom: 0.5rem;
  `}
`;

const StyledCloudinaryPhoto = styled(CloudinaryPhoto)`
  max-width: 6rem;

  ${media.sm`
    max-width: 100%;
  `}
`;

type Props = {
  profilePhoto: gqlMedia;
  thumbnailSize: [number, number] | number[];
  thumbnailCropSettings?: CloudinaryPhotoProps['thumbnailCropSettings'];
  className?: string;
};

const TalentCardPhoto: FC<Props> = ({
  profilePhoto,
  thumbnailSize = THUMBNAIL_DEFAULT_SIZE,
  thumbnailCropSettings,
  className,
}) => {
  return (
    <Wrapper className={className} data-testid="talent-photo-wrap">
      {profilePhoto?.mediaType?.code === MEDIA_TYPE.VIDEO ? (
        <CloudinaryVideoAudio
          isThumbnail
          hidePlayIcon
          mediaStorageStatus={profilePhoto?.mediaStorageStatus?.code || profilePhoto?.mediaStorageStatus}
          fileKey={profilePhoto?.fileKey}
          mediaType={profilePhoto?.mediaType?.code}
          mediaStatus={profilePhoto?.mediaStatus?.code}
          poster={{ transformation: profilePhoto?.transformation }}
          customSize={[...thumbnailSize].reverse()}
          thumbnail={profilePhoto.thumbnail}
          thumbnailCropSettings={thumbnailCropSettings}
        />
      ) : (
        <StyledCloudinaryPhoto
          showThumbnail
          type="sm"
          mediaStorageStatus={profilePhoto?.mediaStorageStatus}
          fileKey={profilePhoto?.fileKey}
          thumbnail={profilePhoto?.thumbnail}
          customSize={thumbnailSize}
          thumbnailCropSettings={thumbnailCropSettings}
          data-qa-id="talent-card-photo"
        />
      )}
    </Wrapper>
  );
};

export default TalentCardPhoto;
